<template>
  <div id="menber_detail">
    <div class="menber_control menber_nav padding-30 background-c-fff m-b-15">
      <form id="goto-pay" action="http://www.jihui88.com/rest/pay/todo" method="post" style="display:none;">
        <input type="hidden" name="paymentConfigId" value=""/>
        <input type="hidden" name="url" value=""/>
        <input type="hidden" name="orderId" value=""/>
        <input type="submit" value="确认支付">
      </form>
      <div class="b_cont">
        <div class="order_1 order_list active_bg" data-active_bg="1">
          <ul>
            <li class="m-b-15" :class="{'m_receiving': detail.paymentStatus!=='unpaid' && (detail.shippingStatus==='unshipped' || detail.shippingStatus==='shipped'), 'm_close': detail.orderStatus==='invalid'}">
              <div class="order_b">
                <div class="col-xs-12 col-sm-12 col-md-8 m-b-15 order_info">
                  <div class="text_h1">
                    <p class="m-b-5">
                      <i class="xybicon"></i>
                      <span v-if="detail.orderStatus==='invalid'">已关闭</span>
                      <span v-else-if="detail.paymentStatus==='unpaid'">待支付</span>
                      <span v-else-if="detail.shippingStatus==='unshipped'">待发货</span>
                      <span v-else-if="detail.shippingStatus==='shipped'">待收货</span>
                      <span v-else>已关闭</span>
                    </p>
                    <p v-if="detail.paymentStatus==='unpaid' || item.shippingStatus==='shipped'">请在<span>30min</span>内完成支付</p>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-4 order_btn">
                  <a href="javascript:;" class="order_detail" v-if="detail.orderStatus!=='invalid'" v-on:click="cancelOrder">取消订单</a>
                  <a href="javascript:;" v-on:click="toPay" class="order_pay" v-if="detail.paymentStatus==='unpaid' && detail.shippingStatus==='unshipped'&&detail.orderStatus!=='invalid'">立即付款</a>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="menber_control menber_nav padding-30 background-c-fff m-b-15">
      <div class="b_cont">
        <div class="order_2 order_list active_bg" data-active_bg="2">
          <ul>
            <li class="icon_1 col-xs-3 col-sm-3 col-md-3 active_bg" >
              <div class="detail_icon">
                <i class="xybicon" :style="{'border-color': $store.state.color,'color': $store.state.color}"></i>
                <span class="detail_line detail_line_right" :style="{'background-color': $store.state.color}"></span>
              </div>
              <div class="detail_name">下单</div>
              <div class="detail_time visible-md-block visible-lg-block">{{detail.addTime}}</div>
            </li>
            <li class="icon_2 col-xs-3 col-sm-3 col-md-3" :class="{'active_bg':detail.paymentStatus==='paid'}" >
              <div class="detail_icon">
                <span class="detail_line detail_line_left"></span>
                <i class="xybicon" :style="{'border-color': detail.paymentStatus==='paid'? $store.state.color : '','color': detail.paymentStatus==='paid'? $store.state.color : ''}"></i>
                <span class="detail_line detail_line_right" :style="{'background-color': detail.paymentStatus==='paid'? $store.state.color : ''}"></span>
              </div>
              <div class="detail_name">付款</div>
              <div class="detail_time visible-md-block visible-lg-block"></div>
            </li>
            <li class="icon_3 col-xs-3 col-sm-3 col-md-3" :class="{'active_bg':detail.shippingStatus==='shipped'}" >
              <div class="detail_icon">
                <span class="detail_line detail_line_left"></span>
                <i class="xybicon" :style="{'border-color': detail.shippingStatus==='shipped'? $store.state.color : '','color': detail.shippingStatus==='shipped'? $store.state.color : ''}"></i>
                <span class="detail_line detail_line_right" :style="{'background-color':detail.shippingStatus==='shipped'?$store.state.color:''}"></span>
              </div>
              <div class="detail_name">发货</div>
              <div class="detail_time visible-md-block visible-lg-block"></div>
            </li>
            <li class="icon_4 col-xs-3 col-sm-3 col-md-3" :class="{'active_bg':detail.orderStatus==='completed'}" >
              <div class="detail_icon">
                <span class="detail_line detail_line_left"></span>
                <i class="xybicon" :style="{'border-color': detail.orderStatus==='completed'? $store.state.color : '','color': detail.orderStatus==='completed'? $store.state.color : ''}"></i>
              </div>
              <div class="detail_name">完成</div>
              <div class="detail_time visible-md-block visible-lg-block"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="menber_control menber_nav padding-30 background-c-fff m-b-15">
      <div class="b_cont">
        <div class="order_3 order_list active_bg" data-active_bg="3">
          <div class="table-responsive">
            <table cellspacing="0" cellpadding="0" class="table table-hover table-striped">
              <tbody>
                <tr>
                  <td>商品名称</td>
                  <td>单价</td>
                  <td>数量</td>
                  <td>小计</td>
                </tr>
                <tr v-for="item in detail.orderItemSet">
                  <td class="td_flex">
                    <a href="javascript:;" class="pic">
                      <img :src="item.product.picUrl4" @error="setErrorImg" @click="showPic" width="80" height="80" border="0" />
                    </a>
                    <div class="text_h1">
                      <p class="m-b-5"><a href="javascript:;" :style="{'color': $store.state.color}">{{item.productName}}</a></p>
                      <p>{{item.productAttr}}</p>
                    </div>
                  </td>
                  <td>{{item.product.price}}</td>
                  <td>{{item.productQuantity}}</td>
                  <td>{{item.productPrice}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="menber_control menber_nav padding-30 background-c-fff m-b-15">
      <div class="b_cont">
        <div class="order_4 order_list active_bg" data-active_bg="4">
          <ul class="ul_1">
            <li><strong>订单号 : </strong><span>{{detail.orderSn}}</span></li>
            <li><strong>支付方式 : </strong><span>{{detail.paymentConfigName}}</span></li>
          </ul>
          <ul class="ul_2">
            <li><strong>配送方式 : </strong><span>{{detail.deliveryTypeName}}</span></li>
            <li><strong>收货信息 : </strong><span>{{detail.shipName}} {{detail.shipMobile}} {{detail.shipAddress}}</span></li>
          </ul>
          <ul class="ul_3">
            <li><strong>买家留言 : </strong><span>{{detail.memo}}</span></li>
            <li v-if="detail.shippingSet[0] && detail.shippingStatus==='shipped'"><strong>物流编号/图片 : </strong>
              <span v-if="detail.shippingSet[0].deliverySn.indexOf('upload') > -1  ">
                <img :src="$store.state.imgHost + detail.shippingSet[0].deliverySn" @error="setErrorImg" @click="showPic"/>
              </span>
              <span v-else>{{detail.shippingSet[0].deliverySn}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="menber_control menber_nav padding-30 background-c-fff">
      <div class="b_cont">
        <div class="order_5 order_list active_bg" data-active_bg="5">
          <div class="table-responsive">
            <table cellspacing="0" cellpadding="0" class="table table-hover table-striped">
              <tr>
                <td>订单金额</td>
                <td>运费</td>
                <td>优惠</td>
                <td>支付手续费</td>
                <td>实付金额</td>
              </tr>
              <tr>
                <td><span class="raduis-3">￥{{detail.productTotalPrice}}RMB</span><i>+</i></td>
                <td><span class="raduis-3">￥{{detail.deliveryFee}}RMB</span><i>+</i></td>
                <td><span class="raduis-3">￥0RMB</span><i>+</i></td>
                <td><span class="raduis-3">￥{{detail.paymentFee}}RMB</span><i>=</i></td>
                <td><span class="raduis-3">￥{{detail.totalAmount}}RMB</span></td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      picDomain: 'http://img.jihui88.com/',
      detail: {},
      detailTest: {
        shipArea: '浙江省绍兴市越城区',
        shipAreaPath: '402881882ba8753a012ba8da48e000b0,402881882ba8753a012ba8db3e9b00b6,402881e44da29af5014da3609e26035c',
        shipAddress: '鸿通金都27幢4单元208室',
        shipZipCode: '312000',
        shipPhone: 'null',
        shipMobile: '13588506961',
        memo: '',
        enterpriseId: 'Enterp_0000000000000000000049090',
        paytype: 'pc',
        belongId: null,
        orderStatus: 'invalid',
        paymentStatus: 'unpaid',
        shippingStatus: 'unshipped',
        orderId: '8a9e457e608d146001609222bf4e010e',
        paymentConfigName: '支付宝支付',
        totalAmount: 0.01,
        paidAmount: 0,
        memberPoint: null,
        orderItemSet: [
          {
            product: {
              name: '商品综合测试',
              price: 0.01,
              productId: 'Product_000000000000000000602353',
              picPath: 'upload/j/j2/jihui88/picture/2017/06/28/8765af0d-1f3d-43df-bebe-7dbf8ab1b89c.jpg'
            },
            productAttr: '尺寸:大号;颜色:红色;',
            productQuantity: 1,
            itemId: '8a9e457e608d146001609222bf73010f',
            addTime: 1514618449336,
            productName: '商品综合测试',
            updateTime: 1514280238963,
            deliveryQuantity: 0,
            totalDeliveryQuantity: 0,
            productSn: 'SN_3D10F50A542E',
            buyname: 'jihuibuy',
            productPrice: 0.01,
            productHtmlFilePath: null
          }
        ],
        paySn: null,
        orderSn: '20171226091157',
        addTime: '2017-12-26 17:23:58',
        deliveryFee: 0,
        productTotalPrice: 0.01,
        updateTime: '2017-12-26 17:23:58',
        deliveryTypeName: '包邮',
        shipName: '王永进',
        paymentFee: 0,
        productWeight: 10,
        productWeightUnit: 'g',
        productTotalQuantity: 1,
        shippingSet: [],
        invoiceName: null,
        invoiceAmount: null,
        outTradeNo: null,
        integralMoney: 0
      }
    }
  },
  created () {
    this.get()
  },
  methods: {
    get () {
      var ctx = this
      window.$.ajax({
        url: '/rest/api/shop/order/detail/' + this.$route.params.id,
        success (res) {
          if (res.success) {
            ctx.detail = res.attributes.data
            ctx.paymentConfigList = res.attributes.paymentConfigList
          } else {
            // window.alert(res.msg)
          }
        }
      })
    },
    toPay () {
      window.ua = navigator.userAgent.toLowerCase()
      if (window.ua.match(/MicroMessenger/i)) {
        let orderPay = {
          orderId: this.detail.orderId,
          paymentConfigId: this.detail.paymentConfig.paymentId
        }
        window.parent.postMessage({ orderPay: orderPay }, '*')
      } else {
        window.$('#menber_detail input[name=paymentConfigId]').val(this.detail.paymentConfig.paymentId)
        window.$('#menber_detail input[name=orderId]').val(this.detail.orderId)
        window.$('#goto-pay').submit()
      }
    },
    cancelOrder () {
      var ctx = this
      window.$.ajax({
        type: 'post',
        url: 'http://www.jihui88.com/rest/api/shop/order/invalid/' + this.$route.params.id,
        success (res) {
          if (res.success) {
            ctx.detail.orderStatus = 'invalid'
          } else {
            window.alert(res.msg)
          }
        }
      })
    },
    setErrorImg (e) {
      e.target.src = 'static/images/pic.jpg'
    },
    showPic (e) {
      this.$parent.$refs.pic.show(e.target.src)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/OrderDetail.vue